import {isIphone, isIpad, isWeiXin, isApp, isAndroid, isOTT, getInvoker, getPlatform} from './env'
import get_param from '../param'
import config from '../../constant/config'
import {ANALYSIS_ID} from '../../constant/CookieKeys'
import {uuid} from '../../tools/uuid'
import * as Cookie from 'tiny-cookie'
import {get_ticket} from './ticket'
import {setShare} from './share'
import {ACTION_GET_USER_INFO} from '../../constant/eventbus'

export const DEFAUL_APP_VERSION = '5.9.9_vipact';

export function init_gact() {
  window.gact = {
    is_app: isApp(),
    is_h5: !isApp(),
    is_wx: isWeiXin(),
    is_iphone: isIphone(),
    is_ipad: isIpad(),
    is_android: isAndroid(),
    is_ott: isOTT(),
    is_mpp: !isOTT(),
    is_ios_app: isApp() && !isAndroid(),
    os: isAndroid() ? 'android' : 'ios',
    invoker: getInvoker(),
    platform: getPlatform(),
    source: get_param('source') || window.rootdata.act_name,
    test_env: get_param('test_env') === "1" ? 1 : 0, //是否是内测环境
    debug: get_param('debug') === "1" ? 1 : 0, //是否模拟app环境
    edit: get_param('edit') === "1" ? 1 : 0, //是否是edit模式，显示边框
    edit_color: get_param('edit_color') || '#06c',
    share_id: get_param('share_id'),
    auto_login:get_param('auto_login') === '1' //自动登陆开关
  } //全局变量

  let analysis_id = Cookie.get(ANALYSIS_ID);
  if (!analysis_id) {
    analysis_id = "act" + uuid();
    Cookie.set(ANALYSIS_ID, analysis_id);
    gact.analysis_id = analysis_id;
  } else {
    gact.analysis_id = analysis_id;
  }

  if (gact.test_env) {
    gact.config = config['test_env']
  } else {
    gact.config = config['online_env']
  }

  if (gact.is_app) {
    get_ticket((ticket) => {
      window.$bus.$emit(ACTION_GET_USER_INFO, ticket);
      get_device_info(function () {
      })
    });
  } else {
    get_ticket((ticket) => {
      window.$bus.$emit(ACTION_GET_USER_INFO, ticket);
    });
  }
}

export function get_device_info(cb) {
  if (window.gact.is_app) {
    if (gact.debug) {
      window.$bus.device_info = {
        appVersion: DEFAUL_APP_VERSION,
        mac: '0000-0000-0000',
        did: '0000-0000-0000',
        osType: window.gact.os,
      };
    } else {
      MgtvApi.getDeviceInfo(function (_device_info) {
        console.log(_device_info, typeof _device_info)
        if (_device_info.length !== 0) {
          const device_info = JSON.parse(_device_info);
          //防止老版本中mac和did为空，导致下单失败
          if (!device_info.mac) {
            device_info.mac = '0000-0000-0000';
          }
          if (!device_info.did) {
            device_info.did = '0000-0000-0000';
          }
          window.$bus.device_info = device_info;
        } else {
          window.$bus.device_info = {
            appVersion: '5.9.9_vipact',
            mac: '0000-0000-0000',
            did: '0000-0000-0000',
            osType: window.gact.os,
          };
        }
        if (cb) {
          cb();
        }
      });
    }
  }
}




// WEBPACK FOOTER //
// ./src/tools/mgtv/gact.js